module.exports = __webpack_public_path__ + "static/media/468x60_0005_en.481fdbfe.png";